import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { GeneralService } from "../../services/GeneralService";

const ModalSelectDocOnlineLanguage = ({isOpen, setIsOpen, onSubmit}) => {
  const { t } = useTranslation();
  const [languages, setLanguages] = useState([]);
  const [languageSelected, setLanguageSelected] = useState(0);

  useEffect(() => {
    if (!isOpen) return;

    GeneralService.getVitaeLanguages().then((data) => {
      const english = data.find((x) => x.initials === "EN");

      if (english) {
        setLanguageSelected(Number(english.id));
      }

      setLanguages(data);
    });
  }, [isOpen]);

  function onChangeLanguage({ target }) {
    setLanguageSelected(Number(target.value));
  }

  function submit() {
    setIsOpen(false);
    onSubmit(languageSelected);
  }

  return (
    <ModalContainer
      modalTitle={t("Choose a language")}
      isOpen={isOpen}
      submitButtonTitle={t("Send")}
      submitButtonType="submit"
      submitButtonAction={submit}
      closeModal={() => setIsOpen(false)}
      crossmarkAction={() => setIsOpen(false)}
    >
      <div className="mb-3">
        {t("What language should the Doc Online be generated?")}
      </div>

      <div className="col-md-4">
        <div className="form-group">
          <select
            className="form-select"
            value={languageSelected}
            onChange={onChangeLanguage}
          >
            {languages.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.languageDescription)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ModalSelectDocOnlineLanguage;